import React from 'react';
import { Info } from 'lucide-react';

interface TooltipProps {
  content: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ content }) => {
  return (
    <div className="relative inline-block group">
      <button
        type="button"
        className="inline-flex items-center p-1 rounded-full hover:bg-gray-100 transition-colors"
        aria-label="Show information"
      >
        <Info className="w-4 h-4 text-blue-500" />
      </button>
      <div 
        className="invisible group-hover:visible absolute z-[9999] w-64 p-2 text-sm text-gray-600 bg-white rounded-lg shadow-lg border border-gray-200"
        style={{
          top: 'calc(100% + 5px)',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        {content}
      </div>
    </div>
  );
};